import type { LogFilters } from '../types/logs';

/**
 * Texto do diálogo de confirmação do "Limpar logs": diz EXATAMENTE o que vai
 * sair — com filtro ativo, só o recorte; sem filtro, a tabela inteira. O suporte
 * decide pelo texto, então ele não pode falar em "filtro" quando é tudo.
 */
export function descreverLimpezaLogs(filtros: LogFilters, total: number): string {
  const partes: string[] = [];
  if (filtros.level) partes.push(`nível ${filtros.level}`);
  if (filtros.dias) partes.push(filtros.dias === 1 ? 'últimas 24 horas' : `últimos ${filtros.dias} dias`);
  if (filtros.correlationId) partes.push(`correlation ${filtros.correlationId}`);
  if (filtros.q) partes.push(`busca "${filtros.q}"`);
  const n = `${total.toLocaleString('pt-BR')} evento(s)`;
  return partes.length > 0
    ? `Serão apagados os ${n} que casam com o filtro atual (${partes.join(', ')}). Os demais ficam.`
    : `Todos os ${n} do log técnico serão apagados.`;
}
